import React from "react";
import { Link } from "gatsby"
import SharePanel from "./share";
import { CategoryColor } from "../utils/CategoryColor";


function PostMobile({
  primary_category_override_link,
  primary_category_override,
  title_clean,
  uri,
  featuredImage,
  author,
  video_embedded_home,
  video_content
}
)
{
  return (
      <div
        className="show_mobile"
        style={{ display: "none", height: "90px" }}
      >
        <span
          className="byline byline_mobile"
          id="byline_mobile"
          style={{ width: "100%", backgroundColor: "white" }}
        >
          <span
            className="posted-on posted-on_mobile"
            id="posted_on_mobile"
            style={{
              display: "flex",
              width: "100%",
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            <Link
              style={{ width: "fit-content" }}
              to={primary_category_override_link}
            >
              <div
                className="newmag_mobile_primary_category"
                id="newmag_mobile_primary_category"
                style={{
                  marginLeft: "15px",
                  minWidth: "68px",
                  fontSize: "13px",
                  borderRadius: "5px",
                  //gestire se primary_category_override è undefined
                  backgroundColor: new CategoryColor(
                    primary_category_override
                  ).color,
                  color: "white",
                  textAlign: "center",
                  width: "fit-content",
                  padding: "10px",
                }}
              >
                {primary_category_override}
              </div>
            </Link>
            <SharePanel
              title={title_clean}
              components_name_md5={"_headermobile" + uri}
              //img={featuredImage ? featuredImage.node.mediaItemUrl : ""}
              img={ featuredImage ? typeof featuredImage.mediaItemUrl!="undefined" ? featuredImage.node.mediaItemUrl:featuredImage:""}
              author={author && author.name ? author.name : ""}
              video={JSON.stringify(video_embedded_home)}
              is_media={video_content}
            />
          </span>
        </span>
      </div>
    )
}

export default PostMobile;
